import React from 'react';
import '../styles/styles.scss';
import '../styles/custom.css';

class Loader extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <div className="loader-wrap">
            <div className="loader"></div> 
        </div>
    )
  }
}

export default Loader;